// Phase 13 — Geometry Randomisation Engine API client.
// Thin axios wrappers, mirrors ``api/pkCampaigns.js`` conventions.
import { api as client } from "@/api/client";

const BASE = "/api/geometry-campaigns";

export const geometryCampaigns = {
    create: (body) => client.post(BASE, body).then((r) => r.data),
    list: (params = {}) =>
        client.get(BASE, { params }).then((r) => r.data),
    get: (id) => client.get(`${BASE}/${id}`).then((r) => r.data),
    cancel: (id) =>
        client.post(`${BASE}/${id}/cancel`).then((r) => r.data),
    // Phase 14.8 W2 — atomic delete (Mongo doc + any on-disk artefacts).
    // 204 on success, 409 on queued/running (must cancel first), 404 on
    // unknown id or cross-tenant access.
    remove: (id) => client.delete(`${BASE}/${id}`).then((r) => r.status),
    registry: () => client.get(`${BASE}/registry`).then((r) => r.data),
    // Server-rendered Pk heatmap PNG. Returned as a blob so the
    // bearer header travels with the request (mirrors Phase 12's
    // `convergencePng` pattern).
    heatmapPng: (
        id,
        { axes_x, axes_y, resolution, colormap } = {},
    ) =>
        client
            .get(`${BASE}/${id}/heatmap.png`, {
                params: { axes_x, axes_y, resolution, colormap },
                responseType: "blob",
            })
            .then((r) => r.data),
    // Phase 14.10 hot-fix — auth-bearing PDF/DOCX download. Returns
    // { blob, filename } so the caller can wire it through
    // URL.createObjectURL → temp anchor click → revoke. Replaces the
    // earlier `<a href={reportUrl(...)}>` pattern that PM hit with
    // 401 (anchor-href fetch doesn't carry the JWT in the
    // Authorization header).
    downloadReport: (id, format = "pdf") =>
        client
            .get(`${BASE}/${id}/report`, {
                params: { format },
                responseType: "blob",
            })
            .then((r) => {
                const cd = r.headers?.["content-disposition"] || "";
                const match = cd.match(/filename="?([^"]+)"?/);
                return {
                    blob: r.data,
                    filename: match
                        ? match[1]
                        : `geometry_report_${id}.${format}`,
                };
            }),
    reportUrl: (id, format = "pdf") =>
        `${BASE}/${id}/report?format=${encodeURIComponent(format)}`,
};

export default geometryCampaigns;
